import { useMutation } from '@tanstack/react-query';
import { PricingCalculationPayload, PricingCalculationResponse } from './types';

const PRICING_API_URL = 'https://us-central1-the-pricing-wizard.cloudfunctions.net/pricing-proxy';

/**
 * Hook to calculate pricing based on provided configuration
 */
export function usePricingCalculation() {
	return useMutation<PricingCalculationResponse, Error, PricingCalculationPayload>({
		mutationFn: async (payload: PricingCalculationPayload) => {
			const response = await fetch(PRICING_API_URL, {
				body: JSON.stringify(payload),
				headers: { 'Content-Type': 'application/json' },
				method: 'POST',
			});

			if (!response.ok) {
				throw new Error(`Failed to calculate pricing: ${response.statusText}`);
			}

			const data = await response.json();
			return data;
		},
	});
}

/**
 * Hook to refresh the pricing cache
 */
export function useRefreshPricingCache() {
	return useMutation<any, Error, void>({
		mutationFn: async () => {
			const response = await fetch(PRICING_API_URL, {
				body: JSON.stringify({ refreshCache: true }),
				headers: { 'Content-Type': 'application/json' },
				method: 'POST',
			});

			if (!response.ok) {
				throw new Error(`Failed to refresh cache: ${response.statusText}`);
			}

			const data = await response.json();
			return data;
		},
	});
}
